import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';
import { ClientEvents } from '../../constants/clientEvents';

export class Event100ClicksHandler {
    public handle(): void {
        ClientEventEmitter.fireEvent(ClientEvents.TUTORIAL_100_CLICKS);
    }
}
